<template>
  <img :class="['lazy-image', {'lazy-image--loaded' : isLoaded}]" ref="img" @load="isLoaded = true" />
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'

const props = withDefaults(defineProps<{
  src: string
  parentContainer?: HTMLElement | null
}>(), {
  parentContainer: null
})

const emits = defineEmits<{
  (event: 'viewportIntersect'): void
}>()

const img = ref<HTMLImageElement | null>(null)
const isLoaded = ref(false)
let loadImageTimeout: ReturnType<typeof setTimeout> |  null

onMounted(() => {
  if (img.value) {
    new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        if (entries.length === 1 && entries[0].isIntersecting) {
          loadImageTimeout = setTimeout(() => {
            if (img.value && img.value.src === '') { 
              img.value.src = props.src
              loadImageTimeout = null
            }
          }, 400)
          emits('viewportIntersect')
        } else if (loadImageTimeout) {
          clearTimeout(loadImageTimeout)
          loadImageTimeout = null
        }   
        if ( isLoaded.value && img.value) {
          img.value.removeAttribute('src')
          isLoaded.value = false
        }
      },
      {
        // Observe intersection with the viewport
        root: props.parentContainer,
        // We may want to adjust this to allow images to start loading slightly earlier than being in the viewport
        rootMargin: '300px 0px 300px 0px'
      }
    ).observe(img.value)
  }
})

</script>
<style lang="scss">
.lazy-image:not([src]) {
  visibility: hidden;
}
</style>
